import { MembershipLevels } from '@aaa/emember/store-types';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RequestStatus } from '@aaa/emember/types';
import { MembershipRenewState, MobileQueryParams } from './mobile-renew.models';
import { getRouterQueryParams } from '../router/router.selectors';
import { AccountDetailsSelectors } from '../../modules/share/ngrx-helpers/account-details.selectors';
import { getErrorMessage } from '../generic-errors';
import { clubOption } from '../../signals';

export const MOBILE_RENEW_FEATURE_KEY = 'mobile-renew';

export const getMobileRenewFormState = createFeatureSelector<MembershipRenewState>(MOBILE_RENEW_FEATURE_KEY);

export const getMobileRenewFormAction = createSelector(getMobileRenewFormState, ({ formAction }) => formAction);

export const getMobileRenewExecutionData = createSelector(
  getMobileRenewFormState,
  ({ executionData }) => executionData,
);
export const getMobileRenewExecutionRequestStatus = createSelector(
  getMobileRenewFormState,
  ({ executionRequestStatus }) => executionRequestStatus,
);
export const getMobileRenewIsLoadingExecution = createSelector(
  getMobileRenewExecutionRequestStatus,
  (status) => status === RequestStatus.RUNNING,
);

export const getMobileRenewValidationRequestStatus = createSelector(
  getMobileRenewFormState,
  ({ validationRequestStatus }) => validationRequestStatus,
);
export const getMobileRenewIsLoadingValidation = createSelector(
  getMobileRenewValidationRequestStatus,
  (status) => status === RequestStatus.RUNNING,
);

export const getMobileRenewAccountDetails = createSelector(
  getMobileRenewFormState,
  ({ accountDetails }) => accountDetails,
);
export const MembershipMobileRenewAccount = AccountDetailsSelectors(getMobileRenewAccountDetails);

//
export const getMobileRenewErrorMessage = createSelector(
  getMobileRenewFormState,
  ({ executionError, validationError }) => {
    return getErrorMessage(executionError || validationError, clubOption());
  },
);

export const getMobileRenewQuery = createSelector(getRouterQueryParams, (queryParams) => {
  return {
    appId: queryParams['appid'] || queryParams['appId'] || '',
    redirectUri: queryParams['redirect_uri'] || '',
    level: (queryParams['level'] && (queryParams['level'].toUpperCase() as MembershipLevels)) || null,
    rv: queryParams['rv'] === 'true',
    autoRenew: queryParams['autorenew'] === 'true',
  } as MobileQueryParams;
});
